export default __webpack_public_path__ + "static/media/welcome1.c44bb77c.png";